import { IgTooltip } from "@intelligems/ig-theme/IgTooltip";
import { ToggleButton } from "@mui/material";
import { ToggleButtonGroup } from "@src/features/experienceBuilder/toolbar/ToggleButtonGroup";
import { useDispatch, useSelector } from "@src/store";
import { ExperienceBuilderAiSelector } from "@src/store/slices/experienceBuilder/ai";
import {
  ExperienceBuilderAction,
  ExperienceBuilderSelector,
} from "@src/store/slices/experienceBuilder";
import { ExperienceBuilderMode } from "@src/store/slices/experienceBuilder/types";

import { ModeSelectorTooltip } from "./ModeSelectorTooltip";
import { useModeShortcuts } from "./useModeShortcuts";

const tabs: { label: string; value: ExperienceBuilderMode }[] = [
  { label: "Navigate", value: "navigate" },
  { label: "Select", value: "select" },
];

export const ModeSelector = () => {
  const dispatch = useDispatch();
  const mode = useSelector(ExperienceBuilderSelector.getMode);
  const isAiBusy = useSelector(ExperienceBuilderAiSelector.getIsAiBusy);

  useModeShortcuts(!isAiBusy);

  const buttons = tabs.map((tab) => (
    <ToggleButton
      key={tab.value}
      value={tab.value}
      size="small"
      disabled={isAiBusy}
    >
      {tab.label}
    </ToggleButton>
  ));

  return (
    <ModeSelectorTooltip disabled={isAiBusy}>
      <IgTooltip title={isAiBusy ? "AI is busy, please wait..." : ""}>
        <ToggleButtonGroup
          buttons={buttons}
          value={mode}
          control={{
            exclusive: true,
            onChange: (_event, value) => {
              if (!value) {
                return;
              }
              void dispatch(ExperienceBuilderAction.setMode(value));
            },
          }}
        />
      </IgTooltip>
    </ModeSelectorTooltip>
  );
};
